import React, { useState, useEffect } from "react";
import "./RyujinImages.css";
const ryujinImages = [
  {
    src: "./itzy-ryujin/ryujin-001.jpg",
    alt: "Ryujin Image 1",
    title: "ryujin-001.jpg",
    category: "Stage Look",
    caption: "ITZY 'SNEAKERS' Showcase 2022",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-002.jpg",
    alt: "Ryujin Image 2",
    title: "ryujin-002.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-003.jpeg",
    alt: "Ryujin Instagram Update",
    title: "ryujin-003.jpeg",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-004.jpeg",
    alt: "Ryujin Image 3",
    title: "ryujin-004.jpeg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-005.webp",
    alt: "Ryujin Happy Day",
    title: "ryujin-005.webp",
    category: "Funny Moments",
    caption: "Ryujin's infectious smile",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-006.jpg",
    alt: "Ryujin Image 4",
    title: "ryujin-006.jpg",
    category: "Stage Look",
    caption: "ITZY 'SNEAKERS' Performance",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-007.jpg",
    alt: "Ryujin Image 5",
    title: "ryujin-007.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
  },
  {
    src: "./itzy-ryujin/ryujin-008.jpg",
    alt: "Ryujin Image 6",
    title: "ryujin-008.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait session",
  },
  {
    src: "./itzy-ryujin/ryujin-009.jpg",
    alt: "Ryujin Image 7",
    title: "ryujin-009.jpg",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
  },
  {
    src: "./itzy-ryujin/ryujin-010.jpg",
    alt: "Ryujin Image 8",
    title: "ryujin-010.jpg",
    category: "Stage Look",
    caption: "ITZY 'SNEAKERS' Showcase",
  },
  {
    src: "./itzy-ryujin/ryujin-011.jpg",
    alt: "Ryujin Image 9",
    title: "ryujin-011.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-012.jpeg",
    alt: "Ryujin Image 10",
    title: "ryujin-012.jpeg",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-013.jpg",
    alt: "Ryujin Image 11",
    title: "ryujin-013.jpg",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-014.jpg",
    alt: "Ryujin Image 12",
    title: "ryujin-014.jpg",
    category: "Airport Fashion",
    caption: "Casual style",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-015.jpg",
    alt: "Ryujin Image 13",
    title: "ryujin-015.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-016.jpg",
    alt: "Ryujin Image 14",
    title: "ryujin-016.jpg",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-017.jpg",
    alt: "Ryujin Image 15",
    title: "ryujin-017.jpg",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-018.jpg",
    alt: "Ryujin Image 16",
    title: "ryujin-018.jpg",
    category: "Airport Fashion",
    caption: "Casual style",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-019.jpg",
    alt: "Ryujin Image 17",
    title: "ryujin-019.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-020.jpg",
    alt: "Ryujin Image 18",
    title: "ryujin-020.jpg",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-021.jpg",
    alt: "Ryujin Image 19",
    title: "ryujin-021.jpg",
    category: "Stage Look",
    caption: "ITZY showcase",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-022.jpg",
    alt: "Ryujin Image 20",
    title: "ryujin-022.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-023.jpg",
    alt: "Ryujin Image 21",
    title: "ryujin-023.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-024.jpg",
    alt: "Ryujin Image 22",
    title: "ryujin-024.jpg",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-025.jpg",
    alt: "Ryujin Image 23",
    title: "ryujin-025.jpg",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-026.jpg",
    alt: "Ryujin Image 24",
    title: "ryujin-026.jpg",
    category: "Airport Fashion",
    caption: "Casual style",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-027.jpg",
    alt: "Ryujin Image 25",
    title: "ryujin-027.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-028.jpg",
    alt: "Ryujin Image 26",
    title: "ryujin-028.jpg",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-029.jpg",
    alt: "Ryujin Image 27",
    title: "ryujin-029.jpg",
    category: "Stage Look",
    caption: "ITZY showcase",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-030.jpg",
    alt: "Ryujin Image 28",
    title: "ryujin-030.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-031.jpg",
    alt: "Ryujin Image 29",
    title: "ryujin-031.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-032.jpg",
    alt: "Ryujin Image 30",
    title: "ryujin-032.jpg",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-033.jpg",
    alt: "Ryujin Image 31",
    title: "ryujin-033.jpg",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-034.jpg",
    alt: "Ryujin Image 32",
    title: "ryujin-034.jpg",
    category: "Airport Fashion",
    caption: "Casual style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-035.jpg",
    alt: "Ryujin Image 33",
    title: "ryujin-035.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-036.jpg",
    alt: "Ryujin Image 34",
    title: "ryujin-036.jpg",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://twitter.com/ITZYofficial",
  },
  // {
  //   src: "./itzy-ryujin/ryujin-037.mp4",
  //   alt: "Ryujin Video 1",
  //   title: "ryujin-037.mp4",
  // },
  {
    src: "./itzy-ryujin/ryujin-038.jpg",
    alt: "Ryujin Image 35",
    title: "ryujin-038.jpg",
    category: "Stage Look",
    caption: "ITZY showcase",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-039.jpg",
    alt: "Ryujin Image 36",
    title: "ryujin-039.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-040.jpg",
    alt: "Ryujin Image 37",
    title: "ryujin-040.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-041.jpg",
    alt: "Ryujin Image 38",
    title: "ryujin-041.jpg",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-042.jpg",
    alt: "Ryujin Image 39",
    title: "ryujin-042.jpg",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-043.jpg",
    alt: "Ryujin Image 40",
    title: "ryujin-043.jpg",
    category: "Airport Fashion",
    caption: "Casual style",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-044.jpg",
    alt: "Ryujin Image 41",
    title: "ryujin-044.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-045.jpeg",
    alt: "Ryujin Image 42",
    title: "ryujin-045.jpeg",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-046.jpg",
    alt: "Ryujin Image 43",
    title: "ryujin-046.jpg",
    category: "Stage Look",
    caption: "ITZY showcase",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-047.jpg",
    alt: "Ryujin Image 44",
    title: "ryujin-047.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-048.jpeg",
    alt: "Ryujin Image 45",
    title: "ryujin-048.jpeg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-049.jpg",
    alt: "Ryujin Image 46",
    title: "ryujin-049.jpg",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-050.jpg",
    alt: "Ryujin Image 47",
    title: "ryujin-050.jpg",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-051.webp",
    alt: "Ryujin Image 48",
    title: "ryujin-051.webp",
    category: "Airport Fashion",
    caption: "Casual style",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-052.jpg",
    alt: "Ryujin Image 49",
    title: "ryujin-052.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-053.jpg",
    alt: "Ryujin Image 50",
    title: "ryujin-053.jpg",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-054.jpg",
    alt: "Ryujin Image 51",
    title: "ryujin-054.jpg",
    category: "Stage Look",
    caption: "ITZY showcase",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-055.jpg",
    alt: "Ryujin Image 52",
    title: "ryujin-055.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-056.jpg",
    alt: "Ryujin Image 53",
    title: "ryujin-056.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-057.jpg",
    alt: "Ryujin Image 54",
    title: "ryujin-057.jpg",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-058.jpg",
    alt: "Ryujin Image 55",
    title: "ryujin-058.jpg",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-059.jpg",
    alt: "Ryujin Image 56",
    title: "ryujin-059.jpg",
    category: "Airport Fashion",
    caption: "Casual style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-060.jpg",
    alt: "Ryujin Image 57",
    title: "ryujin-060.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-061.jpg",
    alt: "Ryujin Image 58",
    title: "ryujin-061.jpg",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-062.jpg",
    alt: "Ryujin Image 59",
    title: "ryujin-062.jpg",
    category: "Stage Look",
    caption: "ITZY showcase",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-063.jpg",
    alt: "Ryujin Image 60",
    title: "ryujin-063.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-064.jpg",
    alt: "Ryujin Image 61",
    title: "ryujin-064.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-065.jpg",
    alt: "Ryujin Image 62",
    title: "ryujin-065.jpg",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-066.jpg",
    alt: "Ryujin Image 63",
    title: "ryujin-066.jpg",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-067.webp",
    alt: "Ryujin Image 64",
    title: "ryujin-067.webp",
    category: "Airport Fashion",
    caption: "Casual style",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-068.jpeg",
    alt: "Ryujin Image 65",
    title: "ryujin-068.jpeg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-070.jpeg",
    alt: "Ryujin Image 66",
    title: "ryujin-070.jpeg",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-071.jpeg",
    alt: "Ryujin Image 67",
    title: "ryujin-071.jpeg",
    category: "Stage Look",
    caption: "ITZY showcase",
    resource: "https://www.youtube.com/c/ITZY",
  },
  {
    src: "./itzy-ryujin/ryujin-072.jpeg",
    alt: "Ryujin Image 68",
    title: "ryujin-072.jpeg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-073.webp",
    alt: "Ryujin Image 69",
    title: "ryujin-073.webp",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://twitter.com/ITZYofficial",
  },
  {
    src: "./itzy-ryujin/ryujin-074.webp",
    alt: "Ryujin Image 70",
    title: "ryujin-074.webp",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-075.jpeg",
    alt: "Ryujin Image 71",
    title: "ryujin-075.jpeg",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-076.webp",
    alt: "Ryujin Image 72",
    title: "ryujin-076.webp",
    category: "Airport Fashion",
    caption: "Casual style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-077.png",
    alt: "Ryujin Image 73",
    title: "ryujin-077.png",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-078.png",
    alt: "Ryujin Image 74",
    title: "ryujin-078.png",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-079.webp",
    alt: "Ryujin Image 75",
    title: "ryujin-079.webp",
    category: "Stage Look",
    caption: "ITZY showcase",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-080.jpg",
    alt: "Ryujin Image 76",
    title: "ryujin-080.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-081.png",
    alt: "Ryujin Image 77",
    title: "ryujin-081.png",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-082.jpeg",
    alt: "Ryujin Image 78",
    title: "ryujin-082.jpeg",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-083.webp",
    alt: "Ryujin Image 79",
    title: "ryujin-083.webp",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-084.jpeg",
    alt: "Ryujin Image 80",
    title: "ryujin-084.jpeg",
    category: "Airport Fashion",
    caption: "Casual style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-085.webp",
    alt: "Ryujin Image 81",
    title: "ryujin-085.webp",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-086.jpg",
    alt: "Ryujin Image 82",
    title: "ryujin-086.jpg",
    category: "Funny Moments",
    caption: "Ryujin being adorable",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-087.jpg",
    alt: "Ryujin Image 83",
    title: "ryujin-087.jpg",
    category: "Stage Look",
    caption: "ITZY showcase",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-088.jpg",
    alt: "Ryujin Image 84",
    title: "ryujin-088.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-089.jpg",
    alt: "Ryujin Image 85",
    title: "ryujin-089.jpg",
    category: "Solo Shot",
    caption: "Beautiful portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-090.jpg",
    alt: "Ryujin Image 86",
    title: "ryujin-090.jpg",
    category: "Funny Moments",
    caption: "Ryujin being cute",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-091.jpg",
    alt: "Ryujin Image 87",
    title: "ryujin-091.jpg",
    category: "Stage Look",
    caption: "ITZY performance",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-092.jpg",
    alt: "Ryujin Image 88",
    title: "ryujin-092.jpg",
    category: "Airport Fashion",
    caption: "Casual airport style",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-093.jpg",
    alt: "Ryujin Image 89",
    title: "ryujin-093.jpg",
    category: "Stage Look",
    caption: "Energetic performance on stage",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-094.jpg",
    alt: "Ryujin Image 90",
    title: "ryujin-094.jpg",
    category: "Solo Shot",
    caption: "Cream crochet top with hand gesture",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-095.jpg",
    alt: "Ryujin Image 91",
    title: "ryujin-095.jpg",
    category: "Solo Shot",
    caption: "Cream mesh top against blue wall",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-096.jpg",
    alt: "Ryujin Image 92",
    title: "ryujin-096.jpg",
    category: "Solo Shot",
    caption: "Studio portrait in white tee",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-097.jpg",
    alt: "Ryujin Image 93",
    title: "ryujin-097.jpg",
    category: "Solo Shot",
    caption: "Minimalist studio headshot",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-098.jpg",
    alt: "Ryujin Image 94",
    title: "ryujin-098.jpg",
    category: "Solo Shot",
    caption: "Pensive close-up portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-099.jpg",
    alt: "Ryujin Image 95",
    title: "ryujin-099.jpg",
    category: "Solo Shot",
    caption: "Contemplative pose in white tee",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-100.jpg",
    alt: "Ryujin Image 96",
    title: "ryujin-100.jpg",
    category: "Stage Look",
    caption: "Colorful photoshoot on pink ladder",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-101.jpg",
    alt: "Ryujin Image 97",
    title: "ryujin-101.jpg",
    category: "Solo Shot",
    caption: "High ponytail athletic look",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-102.jpg",
    alt: "Ryujin Image 98",
    title: "ryujin-102.jpg",
    category: "Solo Shot",
    caption: "Clean studio portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-103.jpg",
    alt: "Ryujin Image 99",
    title: "ryujin-103.jpg",
    category: "Solo Shot",
    caption: "Soft studio headshot",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-104.jpg",
    alt: "Ryujin Image 100",
    title: "ryujin-104.jpg",
    category: "Solo Shot",
    caption: "Red Bull racing jacket",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-105.jpg",
    alt: "Ryujin Image 101",
    title: "ryujin-105.jpg",
    category: "Airport Fashion",
    caption: "Cozy car selfie in puffer jacket",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-106.jpg",
    alt: "Ryujin Image 102",
    title: "ryujin-106.jpg",
    category: "Airport Fashion",
    caption: "Carrying fan letters in grey hoodie",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-107.jpg",
    alt: "Ryujin Image 103",
    title: "ryujin-107.jpg",
    category: "Airport Fashion",
    caption: "Casual hoodie fan meeting",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-108.jpg",
    alt: "Ryujin Image 104",
    title: "ryujin-108.jpg",
    category: "Airport Fashion",
    caption: "Glasses and white polo look",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-109.jpg",
    alt: "Ryujin Image 105",
    title: "ryujin-109.jpg",
    category: "Funny Moments",
    caption: "School uniform with portable fan",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-110.jpg",
    alt: "Ryujin Image 106",
    title: "ryujin-110.jpg",
    category: "Funny Moments",
    caption: "Outdoor variety show moment",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-111.jpg",
    alt: "Ryujin Image 107",
    title: "ryujin-111.jpg",
    category: "Solo Shot",
    caption: "Red Bull jacket peace sign",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-112.jpg",
    alt: "Ryujin Image 108",
    title: "ryujin-112.jpg",
    category: "Solo Shot",
    caption: "Film-style studio portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-113.jpg",
    alt: "Ryujin Image 109",
    title: "ryujin-113.jpg",
    category: "Stage Look",
    caption: "Pink ladder photoshoot pose",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-114.jpg",
    alt: "Ryujin Image 110",
    title: "ryujin-114.jpg",
    category: "Solo Shot",
    caption: "Navy athletic top with high ponytail",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-115.jpg",
    alt: "Ryujin Image 111",
    title: "ryujin-115.jpg",
    category: "Solo Shot",
    caption: "Neutral studio close-up",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-116.jpg",
    alt: "Ryujin Image 112",
    title: "ryujin-116.jpg",
    category: "Solo Shot",
    caption: "Studio portrait in white tee",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-117.jpg",
    alt: "Ryujin Image 113",
    title: "ryujin-117.jpg",
    category: "Solo Shot",
    caption: "Crochet top against textured wall",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-118.jpg",
    alt: "Ryujin Image 114",
    title: "ryujin-118.jpg",
    category: "Solo Shot",
    caption: "Melancholic close-up portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-119.jpg",
    alt: "Ryujin Image 115",
    title: "ryujin-119.jpg",
    category: "Funny Moments",
    caption: "Playful OK sign with fan",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-120.jpg",
    alt: "Ryujin Image 116",
    title: "ryujin-120.jpg",
    category: "Airport Fashion",
    caption: "Grey hoodie holding fan letters",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-121.jpg",
    alt: "Ryujin Image 117",
    title: "ryujin-121.jpg",
    category: "Airport Fashion",
    caption: "Adjusting glasses outdoors",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-122.jpg",
    alt: "Ryujin Image 118",
    title: "ryujin-122.jpg",
    category: "Solo Shot",
    caption: "Intimate close-up portrait",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-123.jpg",
    alt: "Ryujin Image 119",
    title: "ryujin-123.jpg",
    category: "Solo Shot",
    caption: "Crochet top with hand gesture",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-124.jpg",
    alt: "Ryujin Image 120",
    title: "ryujin-124.jpg",
    category: "Funny Moments",
    caption: "Fan event playful pose",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-125.jpg",
    alt: "Ryujin Image 121",
    title: "ryujin-125.jpg",
    category: "Stage Look",
    caption: "Black shiny jacket peace sign",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-126.jpg",
    alt: "Ryujin Image 122",
    title: "ryujin-126.jpg",
    category: "Stage Look",
    caption: "Behind-the-scenes photoshoot",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-127.jpg",
    alt: "Ryujin Image 123",
    title: "ryujin-127.jpg",
    category: "Solo Shot",
    caption: "Makeup touch-up profile close-up",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-128.jpg",
    alt: "Ryujin Image 124",
    title: "ryujin-128.jpg",
    category: "Solo Shot",
    caption: "Peace sign brown camisole selfie",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-129.jpg",
    alt: "Ryujin Image 125",
    title: "ryujin-129.jpg",
    category: "Solo Shot",
    caption: "Burgundy hair rhinestone makeup selfie",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-130.jpg",
    alt: "Ryujin Image 126",
    title: "ryujin-130.jpg",
    category: "Solo Shot",
    caption: "Moody cinematic close-up",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-131.jpg",
    alt: "Ryujin Image 127",
    title: "ryujin-131.jpg",
    category: "Stage Look",
    caption: "Black leather jacket serious look",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-132.jpg",
    alt: "Ryujin Image 128",
    title: "ryujin-132.jpg",
    category: "Funny Moments",
    caption: "Cute paw pose white ribbed top",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-133.jpg",
    alt: "Ryujin Image 129",
    title: "ryujin-133.jpg",
    category: "Funny Moments",
    caption: "Writing in notebook at fan event",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-134.jpg",
    alt: "Ryujin Image 130",
    title: "ryujin-134.jpg",
    category: "Airport Fashion",
    caption: "Waving with fan letters in grey hoodie",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-135.jpg",
    alt: "Ryujin Image 131",
    title: "ryujin-135.jpg",
    category: "Airport Fashion",
    caption: "Walking with fan mail in grey hoodie",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
  {
    src: "./itzy-ryujin/ryujin-136.jpg",
    alt: "Ryujin Image 132",
    title: "ryujin-136.jpg",
    category: "Airport Fashion",
    caption: "Navy hoodie sunglasses outdoor",
    resource: "https://www.instagram.com/iamfinethankyouandryu/",
  },
];

const RyujinImages = () => {
  const [randomizedImages, setRandomizedImages] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [filteredImages, setFilteredImages] = useState([]);
  const [photoOfTheDay, setPhotoOfTheDay] = useState(null);
  const [likedImages, setLikedImages] = useState(new Set());

  const categories = [
    "All",
    "Stage Look",
    "Airport Fashion",
    "Funny Moments",
    "Solo Shot",
    "Group Shot",
  ];

  useEffect(() => {
    // Shuffle the images on each page load
    const shuffledImages = [...ryujinImages].sort(() => Math.random() - 0.5);
    setRandomizedImages(shuffledImages);
    setFilteredImages(shuffledImages);

    // Set Photo of the Day based on current date
    const today = new Date().getDate();
    const photoIndex = today % ryujinImages.length;
    setPhotoOfTheDay(ryujinImages[photoIndex]);

    // Load liked images from localStorage
    const storedLikes = JSON.parse(
      localStorage.getItem("ryujinLikedImages") || "[]"
    );
    setLikedImages(new Set(storedLikes));
  }, []);

  useEffect(() => {
    if (selectedCategory === "All") {
      setFilteredImages(randomizedImages);
    } else {
      const filtered = randomizedImages.filter(
        (img) => img.category === selectedCategory
      );
      setFilteredImages(filtered);
    }
  }, [selectedCategory, randomizedImages]);

  // Helper to open image in new tab
  const handleImageClick = (src) => {
    window.open(src, "_blank", "noopener,noreferrer");
  };

  // Helper to share image
  const shareImage = (img, platform) => {
    const url = window.location.href;
    const text = `Check out this amazing photo of Ryujin from ITZY! 🌟 ${url}`;

    switch (platform) {
      case "twitter":
        window.open(
          `https://twitter.com/intent/tweet?text=${encodeURIComponent(
            text
          )}&url=${encodeURIComponent(url)}`,
          "_blank"
        );
        break;
      case "instagram":
        // Instagram doesn't support direct sharing, so we'll copy the image URL
        navigator.clipboard.writeText(img.src);
        alert(
          "Image URL copied! You can paste it in your Instagram story or post."
        );
        break;
      case "pinterest":
        window.open(
          `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
            url
          )}&media=${encodeURIComponent(
            img.src
          )}&description=${encodeURIComponent(text)}`,
          "_blank"
        );
        break;
    }
  };

  // Helper to toggle like
  const toggleLike = (imgTitle) => {
    const newLikedImages = new Set(likedImages);
    if (newLikedImages.has(imgTitle)) {
      newLikedImages.delete(imgTitle);
    } else {
      newLikedImages.add(imgTitle);
    }
    setLikedImages(newLikedImages);
    localStorage.setItem(
      "ryujinLikedImages",
      JSON.stringify([...newLikedImages])
    );
  };

  const renderImageRows = (start, end) => (
    <div style={{ display: "flex", alignItems: "start", gap: "2rem" }}>
      {filteredImages.slice(start, end).map((img) => (
        <div key={img.title} style={{ flex: 1 }} className="ryujinImage">
          <img
            src={img.src}
            alt={img.alt}
            style={{ width: "100%", cursor: "pointer" }}
            onClick={() => handleImageClick(img.src)}
            tabIndex={0}
            role="button"
            aria-label={`Open ${img.title} in new tab`}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleImageClick(img.src);
              }
            }}
          />
          {/* <div className="share-buttons">
            <button
              className={`like-btn ${
                likedImages.has(img.title) ? "liked" : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                toggleLike(img.title);
              }}
              title={likedImages.has(img.title) ? "Unlike" : "Like"}
            >
              {likedImages.has(img.title) ? "❤️" : "🤍"}
            </button>
            <button
              className="share-btn twitter"
              onClick={(e) => {
                e.stopPropagation();
                shareImage(img, "twitter");
              }}
              title="Share on Twitter"
            >
              🐦
            </button>
            <button
              className="share-btn instagram"
              onClick={(e) => {
                e.stopPropagation();
                shareImage(img, "instagram");
              }}
              title="Share on Instagram"
            >
              📷
            </button>
            <button
              className="share-btn pinterest"
              onClick={(e) => {
                e.stopPropagation();
                shareImage(img, "pinterest");
              }}
              title="Share on Pinterest"
            >
              📌
            </button>
          </div> */}
          {/* {img.caption && <div className="image-caption">{img.caption}</div>}
          {img.resource && (
            <a
              href={img.resource}
              target="_blank"
              rel="noopener noreferrer"
              className="resource-btn"
              onClick={(e) => e.stopPropagation()}
            >
              Resource
            </a>
          )} */}
          {/* <div className="image-title">{img.title}</div> */}
        </div>
      ))}
    </div>
  );

  return (
    <div className="container">
      <div style={{ flex: 2.5, paddingTop: "2rem" }}>
        <h1
          className="title"
          style={{
            color: "white",
            filter: "brightness(0) invert(1)",
            textAlign: "center",
          }}
        >
          ˚₊·—̳͟͞͞🌟 The Prettiest Girl on Earth   ˖°.𓆩 Shin Ryu-jin 𓆪.°˖
        </h1>
        {/* <h1 className="title">˚₊·—̳͟͞͞♡ The Prettiest Girl on Earth   ˖°.𓆩 류진 𓆪.°˖</h1> */}
      </div>

      {/* Photo of the Day */}
      {/* {photoOfTheDay && (
        <div className="photo-of-day">
          <h2 className="section-title">🌟 Photo of the Day</h2>
          <div className="photo-of-day-card">
            <img
              src={photoOfTheDay.src}
              alt={photoOfTheDay.alt}
              className="photo-of-day-image"
              onClick={() => handleImageClick(photoOfTheDay.src)}
            />
            <div className="photo-of-day-info">
              <h3>{photoOfTheDay.caption || photoOfTheDay.title}</h3>
              {photoOfTheDay.category && (
                <span className="photo-category">{photoOfTheDay.category}</span>
              )}
            </div>
          </div>
        </div>
      )} */}

      {/* Random Image Button */}
      {/* <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <button
          className="random-image-btn"
          onClick={() => {
            const randomIndex = Math.floor(
              Math.random() * randomizedImages.length
            );
            const randomImg = randomizedImages[randomIndex];
            handleImageClick(randomImg.src);
          }}
        >
          🎲 Random Ryujin Photo
        </button>
      </div> */}

      {/* Category Filter */}
      {/* <div className="category-filter">
        <h3
          style={{ color: "white", textAlign: "center", marginBottom: "1rem" }}
        >
          Filter by Category
        </h3>
        <div className="category-buttons">
          {categories.map((category) => (
            <button
              key={category}
              className={`category-btn ${
                selectedCategory === category ? "active" : ""
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div> */}

      {/* Desktop grid view */}
      <div className="desktopRyujinImagesList">
        {Array.from({ length: Math.ceil(filteredImages.length / 3) }, (_, i) =>
          renderImageRows(i * 3, (i + 1) * 3)
        )}
      </div>
      {/* Phone column view */}
      <div className="phoneRyujinImagesList">
        {filteredImages.map((img) => (
          <div key={img.title} className="ryujinImage">
            <img
              src={img.src}
              alt={img.alt}
              style={{ width: "100%", cursor: "pointer" }}
              onClick={() => handleImageClick(img.src)}
              tabIndex={0}
              role="button"
              aria-label={`Open ${img.title} in new tab`}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleImageClick(img.src);
                }
              }}
            />
            {/* <div className="share-buttons">
              <button
                className={`like-btn ${
                  likedImages.has(img.title) ? "liked" : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleLike(img.title);
                }}
                title={likedImages.has(img.title) ? "Unlike" : "Like"}
              >
                {likedImages.has(img.title) ? "❤️" : "🤍"}
              </button>
              <button
                className="share-btn twitter"
                onClick={(e) => {
                  e.stopPropagation();
                  shareImage(img, "twitter");
                }}
                title="Share on Twitter"
              >
                🐦
              </button>
              <button
                className="share-btn instagram"
                onClick={(e) => {
                  e.stopPropagation();
                  shareImage(img, "instagram");
                }}
                title="Share on Instagram"
              >
                📷
              </button>
              <button
                className="share-btn pinterest"
                onClick={(e) => {
                  e.stopPropagation();
                  shareImage(img, "pinterest");
                }}
                title="Share on Pinterest"
              >
                📌
              </button>
            </div> */}
            {/* {img.caption && <div className="image-caption">{img.caption}</div>}
            {img.resource && (
              <a
                href={img.resource}
                target="_blank"
                rel="noopener noreferrer"
                className="resource-btn"
                onClick={(e) => e.stopPropagation()}
              >
                Resource
              </a>
            )} */}
            {/* <div className="image-title">{img.title}</div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RyujinImages;
